/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefilterstatus3Inputs */

const en_ticketpagefilterstatus3 = /** @type {(inputs: Ticketpagefilterstatus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_ticketpagefilterstatus3 = /** @type {(inputs: Ticketpagefilterstatus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Ticketpagefilterstatus3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefilterstatus3 = /** @type {((inputs?: Ticketpagefilterstatus3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefilterstatus3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefilterstatus3(inputs)
	return de_ticketpagefilterstatus3(inputs)
});
export { ticketpagefilterstatus3 as "ticketPageFilterStatus" }